import { defineMessages } from "react-intl";

export const messages = defineMessages({
    resultsPerPageLabel: {
        id: "fastshift.customer-selection.domain-selection-table.results-per-page-label",
        defaultMessage: "Results per page:",
        description: "Label for results per page dropdown"
    },
    resultsCountText: {
        id: "fastshift.customer-selection.domain-selection-table.results-count-text",
        defaultMessage: "{startIndex}-{endIndex} of {totalCount} results",
        description: "Text showing current page results count"
    },
    previousButton: {
        id: "fastshift.customer-selection.domain-selection-table.previous-button",
        defaultMessage: "Previous",
        description: "Previous page button text"
    },
    nextButton: {
        id: "fastshift.customer-selection.domain-selection-table.next-button",
        defaultMessage: "Next",
        description: "Next page button text"
    }
});
